export default __webpack_public_path__ + "static/media/lupa.d1f01f8e.png";